<ng-template #template1>
  <div class="border-0 rounded-0 pb-0">
    <div class="welcome-header">
      <h4 class="modal-title pull-left"></h4>
      <button type="button" class="close hide close-abs pull-right text-right" id="editclose" name="editclose" aria-label="Close" (click)="modalRef.hide();">
        <span aria-hidden="true"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="p-2">
      <h3>Welcome to MOM</h3>
      <p class="text-secondary">Mom is secure Login for all your MOM applications. Use your DEWA credentials to access your applications seamlessly. All in one place and from any device!</p>
      <p class="text-secondary">
        Any Questions?
        drop an email at <a href="mailto:mom@dewa.gov.ae" class="pointer" target="_blank">mom@dewa.gov.ae</a>
      </p>
      <div class="text-center py-3">
        <button class="btn btn-success btn-sm" (click)="modalRef.hide();" >OK</button>
      </div>
    </div>
  </div>
</ng-template>


<style>
  .login-screen app-header {
    display: none !important;
  }
</style>

<div class="container-fluid border-bottom py-3 bg-white">
  <div class="row">
    <div class="col"><a routerLink=""><img class="img-fluid" src="\assets\v2\img\dubai-gov-logo.png" style="max-height: 70px;width: auto;" alt="" /></a></div>
    <div class="col text-center"><img class="img-fluid" src="\assets\v2\img\emirates-logo.png" alt="" /></div>
    <div class="col text-right"><img class="img-fluid" src="\assets\v2\img\dewa-logo.png" alt="" /></div>
  </div>
</div>
<div class="container-fluid bg-white" id="loginScreen">
  <div class="row">
    <div class="col-lg-8 mt-4">
      <div class="p-4 mt-4 welcone-txt">
        <h3 class="pt-4 mb-0 mt-md-4">Welcome to</h3>
        <h2 class="font-weight-bold">Minutes of Meeting (MOM)</h2>
        <p class="text-secondary pt-4">Use Minutes of Meeting (MOM) platform to record, document minutes of meeting digitally and share it  easily by email.</p>

      </div>
    </div>
    <div class="col-lg-4 offset-md-2 p-0 border-left login-bg hgt-login h-100vh">
      <div class="px-2 py-4 bg-white login-box rounded">
        <div class="mx-4 custom-tab position-relative">
          <h5 class="f-bold-dubai py-2">Login Type </h5>
            <div class="form-group">
              <div class="col-lg-12 px-0 py-2">
                <button class="btn btn-success btn-sm py-2 pl-4 pr-4 btn-block" name="action" type="button" (click)="onSubmitSSO()"> DEWA Users Login </button>
              </div>
              <div class="col-lg-12 px-0 py-2">
                <button class="btn btn-success btn-sm py-2 pl-4 pr-4 btn-block" name="action" type="button" (click)="onSubmitCredential()"> External Login </button>
              </div>
              
            </div>
        </div>
      </div>

    </div>
  </div>
</div>

